import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import Arrow from '@gojob/ui-bits/Zigouigouis/ArrowLeft';

const useStyles = () => {
  const { colors, spacing, breakpoint } = useTheme();

  return {
    card: {
      position: 'relative',
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxSizing: 'border-box',
      width: '100%',
      borderRadius: spacing(2),
      margin: spacing(1, 0, 2),
      padding: spacing(2),
      backgroundColor: colors.scienceBlue,
    },
    arrow: {
      position: 'absolute',
      top: '-20%',
      left: spacing(-8),
      color: colors.white,
      height: spacing(8),
      transform: 'rotate(-110deg) scaleY(-1)',
      [breakpoint.up('md')]: {
        left: spacing(6),
      },
    },
    explanation: {
      margin: spacing(1, 0),
    },
  } as const;
};

const Card: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <>
      <Text variant="label">En 12 mois</Text>

      <div css={classes.card}>
        <Arrow css={classes.arrow} />

        <Text inactive gutter={1}>
          Vous épargnez
        </Text>
        <Text css={{ fontWeight: 500 }} variant="headline2" gutter={4}>
          <strong>4 001 € net</strong>
        </Text>

        <Text inactive gutter={1}>
          Mon Cash vous rapporte
        </Text>
        <Text css={{ fontWeight: 500 }} variant="headline2">
          <strong>298 € net</strong>
        </Text>
      </div>

      <Text css={classes.explanation} variant="label">
        Montants nets sur la base d’un taux horaire brut de 10,15 € travaillé 35 h par semaine. Le salaire
        inclut les CP et les IFM. Les intérêts incluent la prime de 100€.
      </Text>
    </>
  );
};

export default Card;
